import React from "react";
import dayjs from "dayjs";
import { Container, Table, Button } from "react-bootstrap";

const Step9ReviewWorkHistoryPage = ({
  form,
  setForm,
  dbWorkHistories = [],
  prevStep,
  setStep,
}) => {
  const localEntries = form.workHistories || [];

  const handleDelete = (index) => {
    const updated = [...localEntries];
    updated.splice(index, 1);
    setForm((prev) => ({ ...prev, workHistories: updated }));
  };

  const handleEdit = (index) => {
    setForm((prev) => ({
      ...prev,
      editingWorkHistory: localEntries[index],
      editingIndex: index,
    }));
    setStep(8);
  };

  return (
    <Container className="my-5">
      <h4 className="mb-4">Review Work History</h4>

      {/* --- DB Entries --- */}
      <h6>Previous Records (Read-only)</h6>
      {dbWorkHistories.length === 0 ? (
        <p>No previous work history found.</p>
      ) : (
        <Table bordered responsive>
          <thead>
            <tr>
              <th>Type</th>
              <th>Name</th>
              <th>From</th>
              <th>To</th>
            </tr>
          </thead>
          <tbody>
            {dbWorkHistories.map((entry) => (
              <tr key={entry.wh_id}>
                <td>{entry.wh_type}</td>
                <td>{entry.wh_name || "-"}</td>
                <td>
                  {entry.wh_datefrom
                    ? dayjs(entry.wh_datefrom).format("YYYY-MM-DD")
                    : "-"}
                </td>
                <td>
                  {entry.wh_dateto
                    ? dayjs(entry.wh_dateto).format("YYYY-MM-DD")
                    : "Present"}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {/* --- Local Entries --- */}
      <h6 className="mt-4">Newly Added (Editable)</h6>
      {localEntries.length === 0 ? (
        <p>No new entries added yet.</p>
      ) : (
        <Table bordered responsive>
          <thead>
            <tr>
              <th>Type</th>
              <th>Name</th>
              <th>From</th>
              <th>To</th>
              <th style={{ width: "100px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {localEntries.map((entry, index) => (
              <tr key={index}>
                <td>{entry.wh_type}</td>
                <td>{entry.wh_name || "-"}</td>
                <td>
                  {entry.wh_datefrom
                    ? dayjs(entry.wh_datefrom).format("YYYY-MM-DD")
                    : "-"}
                </td>
                <td>
                  {entry.wh_dateto
                    ? dayjs(entry.wh_dateto).format("YYYY-MM-DD")
                    : "Present"}
                </td>
                <td className="text-center">
                  <button
                    className="btn btn-outline-secondary btn-sm me-2"
                    onClick={() => handleEdit(index)}
                  >
                    ✏️
                  </button>
                  <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => handleDelete(index)}
                  >
                    🗑
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <div className="d-flex justify-content-between mt-4">
        <Button variant="secondary" onClick={prevStep}>
          ← Back
        </Button>
        <Button variant="outline-primary" onClick={() => setStep(8)}>
          + Add more
        </Button>
        <Button variant="primary" onClick={() => setStep(10)}>
          Next
        </Button>
      </div>
    </Container>
  );
};

export default Step9ReviewWorkHistoryPage;
